import React, { useState, useEffect } from 'react';
import {
  Box, Typography, TextField, Grid, Button, Autocomplete, Snackbar, Alert,
  MenuItem, Dialog, DialogActions, DialogContent, DialogTitle, Card,
  Chip, Stack, CardContent
} from '@mui/material';
import { Country } from 'country-state-city';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import axios from 'axios';
import Resume from './resume';
import { LearnersProfile } from '../../../../../../helper/base_url';

const Section = ({ id, title, children }) => (
  <Box id={id} sx={{ mb: 5 }}>
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Typography variant="h6" color="#043885" gutterBottom>
        {title}
      </Typography>
    </Box>
    {children}
  </Box>
);

const ProfileContent = () => {
  const [data, setData] = useState({
    name: '', email: '', dateofbirth: '', mobile: '',
    country: '', languages: [], experience: '',
    linkedinProfile: '', currentOccupation: '', resumeHeadline: '', keySkills: [],
    education: [],
    highesteducation: '',
    instituteName: '',
    yearOfGraduation: '',
    relevantCoursesProjects: '',
    additionalInformation: '',
    projects: []
  });

  const [newProject, setNewProject] = useState({
    projectType: '',
    projectname: '',
    description: ''
  });

  const [countries, setCountries] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [skillsInput, setSkillInput] = useState('');
  const [languageInput, setLanguageInput] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    setCountries(Country.getAllCountries());
  }, []);

  useEffect(() => {
  const fetchUserProfile = async () => {
    try {
      const res = await axios.get(`${LearnersProfile}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      const fetchedData = res.data.data;

      // Extract education fields if available
      let educationFields = {};
      if (fetchedData.education && fetchedData.education.length > 0) {
        const edu = fetchedData.education[0];
        educationFields = {
          highesteducation: edu.highesteducation || '',
          instituteName: edu.instituteName || '',
          yearOfGraduation: edu.yearOfGraduation?.toString() || '',
          relevantCoursesProjects: edu.relevantCoursesProjects || ''
        };
      }

      setData((prev) => ({
        ...prev,
        ...fetchedData,
        ...educationFields
      }));
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  fetchUserProfile();
}, []);

 const handleOnChange = (e) => {
  const { name, value } = e.target;
  setData(prev => ({ ...prev, [name]: value }));
};

  const handleAddSkill = () => {
    if (skillsInput.trim() && !data.keySkills.includes(skillsInput.trim())) {
      setData((prev) => ({ ...prev, keySkills: [...prev.keySkills, skillsInput.trim()] }));
      setSkillInput('');
    }
  };

  const handleRemoveSkill = (skillToRemove) => {
    setData((prev) => ({
      ...prev,
      keySkills: prev.keySkills.filter((skill) => skill !== skillToRemove),
    }));
  };

  const handleAddLanguage = () => {
    const trimmedLanguage = languageInput.trim();
    if (trimmedLanguage && !data.languages.includes(trimmedLanguage)) {
      setData((prev) => ({ ...prev, languages: [...prev.languages, trimmedLanguage] }));
      setLanguageInput('');
    }
  };

  const handleRemoveLanguage = (languageToRemove) => {
    setData((prev) => ({
      ...prev,
      languages: prev.languages.filter((language) => language !== languageToRemove),
    }));
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setNewProject({ projectType: '', projectname: '', description: '' });
  };

  const handleProjectInputChange = (e) => {
    const { name, value } = e.target;
    setNewProject((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddProjects = () => {
    setData((prev) => ({
      ...prev,
      projects: [...prev.projects, newProject],
    }));
    handleCloseDialog();
  };

  const handleDeleteProjects = (index) => {
    setData((prev) => ({
      ...prev,
      projects: prev.projects.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setSnackbar({ open: true, message: 'User is not authenticated. Please log in.', severity: 'error' });
        return;
      }

      const updatedData = {
        ...data,
        education: [{
          highesteducation: data.highesteducation,
          instituteName: data.instituteName,
          yearOfGraduation: Number(data.yearOfGraduation),
          relevantCoursesProjects: data.relevantCoursesProjects,
        }],
        academicProjects: data.projects.filter(p => p.projectType === 'academic'),
        freelancingProjects: data.projects.filter(p => p.projectType === 'freelance'),
      };

      const res = await axios.put(`${LearnersProfile}`, updatedData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (res.status === 200) {
        setSnackbar({ open: true, message: res.data.message || 'Profile updated successfully!', severity: 'success' });
      } else {
        setSnackbar({ open: true, message: 'Unexpected response from the server.', severity: 'warning' });
      }
    } catch (err) {
      //console.error('Error updating profile:', err);
      const errorMessage = err.response?.data?.message || 'Failed to update profile. Please try again later.';
      setSnackbar({ open: true, message: errorMessage, severity: 'error' });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ open: false, message: '', severity: 'success' });
  };

  return (
    <Box sx={{ p: "10px" }}>
      {/* <Section id="Resume" title="Resume" onSaveClick={() => handleSave('Resume')}> */}
      <Box>
        <Resume />
      </Box>
      {/* </Section> */}
      <Section id="PersonalDetails" title="1. Personal Details">
        <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Email"
            // placeholder="Enter your email"
            fullWidth
            name="email"
            value={data.email}
             InputProps={{ readOnly: true }}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Full Name"
            placeholder="Enter your full name"
            fullWidth
            name="name"
            value={data.name}
            onChange={handleOnChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            type="date"
            label="Date of Birth"
            name='dateofbirth'
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={data.dateofbirth ? new Date(data.dateofbirth).toISOString().split('T')[0] : ''}
            onChange={handleOnChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <PhoneInput
            country={'in'}
            name="mobile"
            value={String(data.mobile || '')} // Always ensure it's a string
            inputStyle={{ inlineSize: '100%' }}
            placeholder="Enter phone number"
            onChange={(value) =>
              setData((prev) => ({ ...prev, mobile: value || '' }))
            }
          />
        </Grid>
       <Grid item xs={12} sm={6}>
          <Autocomplete
            options={countries} // Array of country objects
            getOptionLabel={(option) => option.name || ''}
            value={countries.find((c) => c.isoCode === data.country) || null}
            onChange={(_, val) => {
              setData({
                ...data,
                country: val?.isoCode || '', // Set country ISO code
                state: '',
                city: ''
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                name='country'
                label="Country"
                placeholder="Select your country"
                sx={{ inlineSize: '100%' }} 
                onChange={handleOnChange}
              />
            )}
          />
        </Grid>
      <Grid item xs={12} container alignItems="center" gap={10} style={{ display: 'flex' }}>
      <Grid item xs={8}>
        <TextField
          label="Languages"
          name="languages"
          placeholder="Enter languages you speak"
          fullWidth
          value={languageInput}
          onChange={(e) => setLanguageInput(e.target.value)}
        />
      </Grid>
      <Grid item>
        <Button variant="contained" onClick={handleAddLanguage}>
          Add 
        </Button>
      </Grid>
      </Grid>
      <Grid item xs={12}>
        <Stack direction="row" spacing={1} flexWrap="wrap">
          {data.languages.map((language, index) => (
            <Chip
              key={index}
              label={language}
              onDelete={() => handleRemoveLanguage(language)}
              color="primary"
              sx={{ marginBlockEnd: 1 }}
            />
          ))}
        </Stack>
       </Grid>
        <Grid item xs={12}>
          <TextField
            label="LinkedIn Profile"
            name='linkedinProfile'
            placeholder="Paste your LinkedIn profile URL"
            fullWidth
            value={data.linkedinProfile}
            onChange={handleOnChange}
          />
        </Grid>
      </Grid>
      <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        mt: 2,
      }}
    >
      <Button
        variant="contained"
        onClick={handleSubmit}
        sx={{
          backgroundColor: 'rgb(27, 110, 244)',
          color: '#fff',
          '&:hover': {
            backgroundColor: 'rgb(0, 98, 255)',
          },
          textTransform: 'none',
          px: 2,
          fontWeight: 'bold',
          borderRadius: 2,
          boxShadow: 2,
        }}
      >
        Save
      </Button>
      </Box>
      </Section>
      {/* section 3 */}
        <Section id="CareerProfile" title="2. Career Profile">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Resume Headline"
              name="resumeHeadline"
              placeholder='A short sentence highlighting your skills (e.g., "Experienced Product Manager")'
              fullWidth
              value={data.resumeHeadline}
              onChange={handleOnChange}
            />
          </Grid>
        <Grid item xs={12} container alignItems="center" gap={4} style={{ display: 'flex' }}>
        <Grid item xs={8}>
          <TextField
            label="Key Skills"
            name='keySkills'
            placeholder="e.g., Product Management, Data Analysis, SEO"
            fullWidth
            value={skillsInput}
            onChange={(e) => setSkillInput(e.target.value)}
          />
        </Grid>

        {/* Add Skill Button */}
        <Grid item>
          <Button variant="contained" onClick={handleAddSkill}>
            Add Skill
          </Button>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Stack direction="row" spacing={1} flexWrap="wrap">
         {data.keySkills.map((skill, index) => (
            <Chip
              key={index}
              label={skill}
              onDelete={() => handleRemoveSkill(skill)}
              color="primary"
              style={{ marginBottom : 5 }}
            />
          ))}
        </Stack>
        </Grid>
          <Grid item xs={12}>
            <TextField
              label="Current Occupation"
              name='currentOccupation'
              select
              fullWidth
              value={data.currentOccupation}
              onChange={handleOnChange}
              placeholder="Select your current occupation"
            >
              <MenuItem value="Student">Student</MenuItem>
              <MenuItem value="Full-time Employee">Full-time Employee</MenuItem>
              <MenuItem value="Freelancer">Freelancer</MenuItem>
              <MenuItem value="Intern">Intern</MenuItem>
            </TextField>
          </Grid>
          </Grid>
            <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          mt: 2,
        }}
      >
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{
            backgroundColor: 'rgb(27, 110, 244)',
            color: '#fff',
            '&:hover': {
              backgroundColor: 'rgb(0, 98, 255)',
            },
            textTransform: 'none',
            px: 2,
            fontWeight: 'bold',
            borderRadius: 2,
            boxShadow: 2,
          }}
        >
          Save
        </Button>
        </Box>
        </Section>
          {/* section 4 */}
         <Section id="Experience" title="3. Experience (optional)">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                type='text'
                multiline
                label="Experience (in Months)"
                name="experience"
                placeholder="e.g., 2 years or 6 months"
                fullWidth
                rows={3}
                value={data.experience}
                onChange={handleOnChange}
              />
            </Grid>
          </Grid>
        </Section>
         {/* // Section 5 - Education */}
        <Section id="Education" title="4. Highest Education">
          <Grid container spacing={2}>
          <Grid item xs={12}>
          <TextField
            label="Highest Education"
            placeholder="e.g., Phd, B.Sc"
            fullWidth
            margin="normal"
            name="highesteducation"
            value={data.highesteducation}
            onChange={handleOnChange}
          />
          <TextField
            label="Institute"
            placeholder="e.g., ABC University"
            fullWidth
            margin="normal"
            name="instituteName"
            value={data.instituteName}
            onChange={handleOnChange}
          />
          <TextField
            label="Graduation Year"
            type="text"
            fullWidth
            margin="normal"
            name="yearOfGraduation"
            inputProps={{ min: 1900, max: 2100, step: 1 }}
            value={data.yearOfGraduation}
            onChange={handleOnChange}
            InputLabelProps={{ shrink: true }}
            helperText="Enter your graduation year"
          />
          <TextField
            label="Courses/Projects"
            placeholder="e.g., Data Structures, Capstone Project on AI"
            fullWidth
            margin="normal"
            name="relevantCoursesProjects"
            value={data.relevantCoursesProjects}
            onChange={handleOnChange}
          />
          </Grid>
          </Grid>
            <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mt: 2,
          }}
        >
      <Button
        variant="contained"
        onClick={handleSubmit}
        sx={{
          backgroundColor: 'rgb(27, 110, 244)',
          color: '#fff',
          '&:hover': {
            backgroundColor: 'rgb(0, 98, 255)',
          },
          textTransform: 'none',
          px: 2,
          fontWeight: 'bold',
          borderRadius: 2,
          boxShadow: 2,
        }}
      >
        Save
      </Button>
      </Box>
          </Section>
        {/* Section 6 - Projects */}
        <section id="Projects">
          <Typography variant="h6" gutterBottom sx={{ color: '#043885', fontWeight: 'bold' }}>
           5. Projects (optional)
          </Typography>
          {data.projects.length === 0 ? (
            <Typography variant="body1" color="text.secondary" sx={{ my: 2 }}>
              No projects added yet.
            </Typography>
          ) : (
            <>
              {/* Academic Projects */}
              {data.projects.some(p => p.projectType === 'academic') && (
                <>
                  <Typography variant="body" sx={{ mt: 3, color: '#052659' }}>Academic Projects</Typography>
                  {data.projects
                    .filter(p => p.projectType === 'academic')
                    .map((proj, index) => (
                      <Card
                        key={`academic-${index}`}
                        sx={{
                          my: 2,
                          transition: '0.3s',
                          '&:hover': { boxShadow: 6 }
                        }}
                      >
                        <CardContent>
                          <Typography variant="body" sx={{ color: '#043885' }}>Project Name: <span>{proj.projectname}</span></Typography>
                          <Typography variant="body2" color="text.secondary">Project Description: {proj.description}</Typography>
                        </CardContent>
                        <Button color="error" onClick={() => handleDeleteProjects(index)} sx={{ mx: 2, mb: 1 }}>
                          Delete
                        </Button>
                      </Card>
                    ))}
                </>
              )}

              {/* Freelancing Projects */}
              {data.projects.some(p => p.projectType === 'freelance') && (
                <>
                  <Typography variant="h6" sx={{ mt: 4, color: '#052659' }}>Freelancing Projects</Typography>
                  {data.projects
                    .filter(p => p.projectType === 'freelance')
                    .map((proj, index) => (
                      <Card
                        key={`freelance-${index}`}
                        sx={{
                          my: 2,
                          transition: '0.3s',
                          '&:hover': { boxShadow: 6 }
                        }}
                      >
                        <CardContent>
                          <Typography variant="body" sx={{ color: '#043885' }}><span>Project Name: </span>{proj.projectname}</Typography>
                          <Typography variant="body2" color="text.secondary">Project Description: {proj.description}</Typography>
                        </CardContent>
                        <Button color="error" onClick={() => handleDeleteProjects(index)} sx={{ mx: 2, mb: 1 }}>
                          Delete
                        </Button>
                      </Card>
                    ))}
                </>
              )}
            </>
          )}

          {/* Add New Project Button */}
          <Card sx={{ mt: 3, bgcolor: '#f5f5f5' }}>
            <CardContent>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={6}>
                  <Typography variant="body1" fontWeight="medium">Want to add a new project?</Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Button variant="contained" onClick={handleOpenDialog} sx={{ bgcolor: '#043885', '&:hover': { bgcolor: '#052659' } }}>
                    + Add
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Save Button */}
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 3, bgcolor: '#043885', '&:hover': { bgcolor: '#052659' } }}
            onClick={handleSubmit}
            disabled={data.projects.length === 0}
          >
            Save All Projects
          </Button>

          {/* Dialog */}
          <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
            <DialogTitle sx={{ bgcolor: '#043885', color: 'white' }}>
              Add {newProject.projectType === 'freelance' ? 'Freelancing' : 'Academic'} Project
            </DialogTitle>
            <DialogContent dividers>
              <TextField
                select
                fullWidth
                label="Project Type"
                name="projectType"
                value={newProject.projectType}
                onChange={handleProjectInputChange}
                margin="normal"
              >
                <MenuItem value="academic">Academic Project</MenuItem>
                <MenuItem value="freelance">Freelancing Project</MenuItem>
              </TextField>

              <TextField
                fullWidth
                label="Project Name"
                name="projectname"
                value={newProject.projectname}
                onChange={handleProjectInputChange}
                margin="normal"
              />
              <TextField
                fullWidth
                label="Description"
                name="description"
                value={newProject.description}
                onChange={handleProjectInputChange}
                margin="normal"
                multiline
                rows={4}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialog}>Cancel</Button>
              <Button onClick={handleAddProjects} variant="contained" sx={{ bgcolor: '#043885', '&:hover': { bgcolor: '#052659' } }}>
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </section>
      <Box sx={{ mt: 2 }}>
      <Section id="AdditionalInformation" title="6. Additional Information (optional)">
        <TextField
          label="Additional Info"
          multiline
          name="additionalInformation"
          rows={2}
          fullWidth
          placeholder="E.g., Fluent in Spanish, Volunteered at Red Cross, Member of IEEE"
          value={data.additionalInformation}
          onChange={handleOnChange}
        />
          <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          mt: 2,
        }}
      >
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{
            backgroundColor: 'rgb(27, 110, 244)',
            color: '#fff',
            '&:hover': {
              backgroundColor: 'rgb(0, 98, 255)',
            },
            textTransform: 'none',
            px: 4,
            py: 1.5,
            fontWeight: 'bold',
            borderRadius: 2,
            boxShadow: 2,
          }}
        >
          Save
        </Button>
      </Box>
      </Section>
      </Box>
        {/* Snackbar for success message */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={{ mt: 5 }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity} 
          sx={{ width : '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ProfileContent;
